import type { ExportColumnKeys } from "@/modules/export";
import type { AuditColumnKey } from "./audit.types";

/** Coluna da tela de Auditoria → chave do core na exportação (`null`: fora do arquivo). */
export const AUDIT_EXPORT_COLUMN_KEYS: ExportColumnKeys<AuditColumnKey> = {
  dataHora: "dataHora",
  acao: "acao",
  justificativa: "justificativa",
  modulo: "modulo",
  responsavel: "responsavel",
  acoes: null,
};
